<template>
  <div class="container">
    <app-header :title="title" />
    <van-search v-model="value"
               @click="$router.push('/search')"
                placeholder="搜索商品名称" />
    <div class="recommend-content">
      <Goods :productList="productList"/>
    </div>
  </div>
</template>

<script>
import Goods from './Goods'
import { getBannerGoodList } from '@/api/product/index.js'
export default {
  name: 'Index',
  components: {
    Goods
  },
  data () {
    return {
      value: '',
      productList: [],
      title: '',
      // 是否收藏
      iscollect: false,
      collect: require('@/assets/collect.png'),
      collect01: require('@/assets/collect01.png')
    }
  },
  created () {
    this.title = this.$route.query.name
    this._getProductGood()
  },
  methods: {
    gotoSearchProduct () {
      if (this.value == '') {
        return
      }
      this.$router.push({
        path: '/searchProduct',
        query: {
          name: this.value
        }
      })
    },
    _getProductGood () {
      const params = {
        bannerId: this.$route.query.id,
      }
      getBannerGoodList(params).then((res) => {
        if (res.success) {
          this.productList = res.data
        }
      })
    },
    onNavigate (item) {
      this.$router.push({
        path: 'product/detail',
        query: { id: item.pid }
      })
    },
    // 点击收藏图片,收藏商品
    collectionGoods (index) {
      console.log(index);
    },
    // 点击加入购物车,添加商品到购物车
    addToCart () { console.log(456); }
  }
}
</script>

<style lang="less" scoped>
.container {

  .recommend-content {
    background: #ffffff;
    .item {
      border: 1px solid rgba(243, 243, 243, 1);
      .name {
        height: 38px;
        font-size: 14px;
        font-weight: bold;
        line-height: 17px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }
      .footer {
        display: flex;
        justify-content: space-between;
        .price {
          height: 30px;
          font-size: 16px;
          font-weight: bold;
          line-height: 30px;
          color: rgba(254, 0, 59, 1);
        }
        .box {
          img {
            width: 25px;
            height: 25px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/modules/banner_product_list.vue